module.exports = __webpack_public_path__ + "static/img/textImg.ad729399.png";